import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import { ReadData } from "../../../../providers/Patient.Provider";
import LoadingSpinner from "../../../../partials/loading";
import GlucoseMonitoringList from "./GlucoseMonitoringList";
import { LIST, CREATE, ADD_ROUTINE } from "../../../../queries/glucose-monitoring.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import GlucoseMonitoringForm from "./GlucoseMonitoringForm";
import GlucoseMonitoringDetail from "./GlucoseMonitoringDetail";
import AddRoutineForm from "./AddRoutineForm";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";

function GlucoseMonitoring() {
    // local state
    const [newGlucoseMonitoring, setNewGlucoseMonitoring] = useState(false);
    const [glucoseMonitoring, setGlucoseMonitoring] = useState(null);
    const [uGlucoseMonitoring, setUGlucoseMonitoring] = useState(null);

    // local data
    const patient = ReadData();

    // query
    const { loading, data } = useQuery(LIST, {
        variables: {
            id: patient.lastAdmission || patient.id,
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    // New
    const [PostCreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        update(caches, { data: { StartNewGlucoseMonitoring } }) {
            const { GetGlucoseAssessments } = caches.readQuery({
                query: LIST,
                variables: {
                    id: patient.lastAdmission || patient.id,
                },
            });
            GetGlucoseAssessments.docs.unshift(StartNewGlucoseMonitoring.doc);
            caches.writeQuery({
                query: LIST,
                variables: {
                    id: patient.lastAdmission || patient.id,
                },
                data: { GetGlucoseAssessments },
            });
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.StartNewGlucoseMonitoring) {
                const { message, doc } = d.StartNewGlucoseMonitoring;
                toast.success(message);
                setNewGlucoseMonitoring(false);
                setGlucoseMonitoring(doc);
                scrollTop();
                setUGlucoseMonitoring(null);
            }
        },
    });

    const [updateFunc, { loading: iLoading }] = useMutation(ADD_ROUTINE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.TakeGlucoseRoutine) {
                const { message, doc } = d.TakeGlucoseRoutine;
                toast.success(message);
                setNewGlucoseMonitoring(false);
                setGlucoseMonitoring(doc);
                scrollTop();
                setUGlucoseMonitoring(null);
            }
        },
    });

    /**
     * A function that scrolls the page to top
     */
    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return (
        <>
            <Helmet>
                <title>Patient Health Glucose Monitoring | {appName}</title>
            </Helmet>
            <div className="row justify-content-center">
                {newGlucoseMonitoring && !glucoseMonitoring && !uGlucoseMonitoring && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewGlucoseMonitoring(false);
                                            setGlucoseMonitoring(null);
                                            scrollTop();
                                            setUGlucoseMonitoring(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Start New Glucose Monitoring
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={cLoading} />

                                <GlucoseMonitoringForm
                                    onCancel={() => {
                                        setNewGlucoseMonitoring(false);
                                        setGlucoseMonitoring(null);
                                        scrollTop();
                                        setUGlucoseMonitoring(null);
                                    }}
                                    onSubmit={async (item) => {
                                        await PostCreateFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    admission: patient.lastAdmission,
                                                    patient: patient.id,
                                                },
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newGlucoseMonitoring && !glucoseMonitoring && !uGlucoseMonitoring && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>Glucose Monitoring List</header>
                                <div className="tools">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setNewGlucoseMonitoring(true);
                                            setGlucoseMonitoring(null);
                                            scrollTop();
                                            setUGlucoseMonitoring(null);
                                        }}
                                        className="mdl-button mdl-button--icon btn-primary"
                                    >
                                        <i className="material-icons">add</i>
                                    </button>
                                </div>
                            </div>
                            <div className="card-body m-b-20" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={loading} />
                                {!loading && (
                                    <GlucoseMonitoringList
                                        className="fade-in"
                                        items={data && data.GetGlucoseAssessments.docs}
                                        onView={(item) => {
                                            setNewGlucoseMonitoring(false);
                                            setGlucoseMonitoring(item);
                                            scrollTop();
                                            setUGlucoseMonitoring(null);
                                        }}
                                        onAddRoute={(item) => {
                                            setUGlucoseMonitoring(item);
                                            setNewGlucoseMonitoring(false);
                                            setGlucoseMonitoring(null);
                                            scrollTop();
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {!newGlucoseMonitoring && glucoseMonitoring && !uGlucoseMonitoring && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewGlucoseMonitoring(false);
                                            setGlucoseMonitoring(null);
                                            scrollTop();
                                            setUGlucoseMonitoring(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Glucose Monitoring Detail
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                {/* Detail */}
                                <GlucoseMonitoringDetail
                                    onAddRoute={(item) => {
                                        setUGlucoseMonitoring(item);
                                        setNewGlucoseMonitoring(false);
                                        setGlucoseMonitoring(null);
                                        scrollTop();
                                    }}
                                    item={glucoseMonitoring}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newGlucoseMonitoring && !glucoseMonitoring && uGlucoseMonitoring && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewGlucoseMonitoring(false);
                                            setGlucoseMonitoring(null);
                                            setUGlucoseMonitoring(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Record new Routine
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={iLoading} />
                                <AddRoutineForm
                                    onCancel={() => {
                                        setNewGlucoseMonitoring(false);
                                        setGlucoseMonitoring(null);
                                        setUGlucoseMonitoring(null);
                                        scrollTop();
                                    }}
                                    onSubmit={async (routine) => {
                                        await updateFunc({
                                            variables: { id: uGlucoseMonitoring.id, routine },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default GlucoseMonitoring;
